import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(() => ({
  note: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.mutedText,
  },
  icon: {
    marginRight: 6,
    fontSize: 14,
    verticalAlign: -1,
  },
  supportLink: {
    color: C.linkBlue,
    fontWeight: 500,
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
  },
}))
